import EnterpriseObject from "./eo/EnterpriseObject";

export default function enterpriseObjectClassFactory(name: string) {
    return new EnterpriseObject(name);
}